import {mapToMaterialsById, useMaterials} from '@domain/materials'
import {dataTestId} from '@hconnect/uikit'
import {useUpmPlantContext} from '@hconnect/upm'
import {Stack, Typography, Chip} from '@mui/material'
import moment from 'moment-timezone'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../consts'
import {useMaterialDemandFilters} from '../../../providers'
import {
  type MomentRange,
  longDayNameAndDateFormatter,
  longDayNameAndDateRangeFormatter
} from '../../../utils'

export const MaterialDemandFilterBar: React.FC<{timeframe: MomentRange; timezoneId: string}> = ({
  timeframe,
  timezoneId
}) => {
  const {
    t,
    i18n: {language}
  } = useTranslation(FEATURE_NAMESPACE)
  const formattedTimeframe = longDayNameAndDateRangeFormatter(timeframe, language, timezoneId)
  const {selectedMaterialIds, toggleMaterialId, selectedDate, toggleSelectedDate} =
    useMaterialDemandFilters()
  const {plantId: plantCode} = useUpmPlantContext()
  const {data: materialsById} = useMaterials({
    plantCode,
    options: {select: mapToMaterialsById}
  })

  return (
    <Stack spacing={1} flexShrink={1}>
      <Stack direction="row" spacing={2}>
        <Typography variant="h4" {...dataTestId('demand_selected_range')} flexShrink={0}>
          {formattedTimeframe}
        </Typography>
        <Stack direction="row" sx={{height: ({spacing}) => spacing(3)}}>
          {selectedDate && (
            <Chip
              variant="outlined"
              color="primary"
              size="small"
              label={longDayNameAndDateFormatter(moment(selectedDate), language, {hideYear: true})}
              onDelete={() => toggleSelectedDate(selectedDate)}
              {...dataTestId('date_filter')}
            />
          )}
        </Stack>
      </Stack>
      <Stack
        direction="row"
        spacing={1}
        sx={{flexWrap: 'wrap', rowGap: 1, height: ({spacing}) => spacing(3)}}
      >
        {selectedMaterialIds?.map((materialId) => (
          <Chip
            key={materialId}
            variant="outlined"
            color="primary"
            size="small"
            label={materialsById?.[materialId].name ?? t('common.loading')}
            onDelete={() => toggleMaterialId(materialId)}
            {...dataTestId('material_filter')}
          />
        ))}
      </Stack>
    </Stack>
  )
}
